const routes = {
  panel: {
    HomePanel: "/panel",
    loyalityLevelEndUserPage: "/panel/loyalityLevel",
    profile: {
      tagrani: "/panel/profile/tagrani",
      bookero: "/panel/profile/bookero",
    },
    
    discount: {
      // bookero: {
      //   create: "/panel/discount/bookero/create",
      //   list: "/panel/discount/bookero/list",
      // },
      admin: {
        create: "/panel/discount/admin/create",
        list: "/panel/discount/admin/list",
      },
    },
    service: {
      list: "/panel/services",
      create: "/panel/services/create",
      update: "/panel/services/update/:id",
      packages: {
        list: "/panel/services/packages",
        create: "/panel/services/packages/create",
        update: "/panel/services/packages/update/:id",
        servicePackage: {
          list: "/panel/services/packages/servicePackage/:pId",
        },
      },
    },
    products: {
      create: "/panel/products/create",
      edit: "/panel/products/:id",
      list: "/panel/products",
    },
    providers: {
      create: "/panel/providers/create",
      edit: "/panel/providers/:id",
      list: "/panel/providers/list",
      financial: "/panel/providers/financial",
    },
    orders: {
      create: "/panel/orders/create",
      edit: "/panel/orders/:id",
      list: "/panel/orders",
    },
    financial: {
      wallet: "/panel/financial/wallet",
      transactions: "/panel/financial/transactions",
    },
    support: {
      list: "/panel/support",
      create: "/panel/support/create",
    },
    webScraper: {
      divarAuth: {
        create: "/panel/webScraper/divarAuth/create",
        list: "/panel/webScraper/divarAuth/list",
        edit: "/panel/webScraper/divarAuth/edit/:id",
      },
    },

    auth: {
      users: {
        list: "/panel/auth/users",
        role: "/panel/auth/users/:id/role",
      },
      roles: {
        list: "/panel/auth/roles",
        create: "/panel/auth/roles/create",
        edit: "/panel/auth/roles/:id",
        permisson: "/panel/auth/roles/:id/permission",
        menu: "/panel/auth/roles/:id/menu",
      },
      permissions: {
        list: "/panel/auth/permissions",
        create: "/panel/auth/permissions/create",
        edit: "/panel/auth/permissions/:id",
      },
    },
    bookeroUser: {
      language: {
        list: "/panel/bookerouser/language/list",
      },
      socialNetworks: {
        list: "/panel/bookerouser/socialNetworks",
      },
    },
    management: {
      sms: {
        list: "/panel/management/sms/list",
        edit: "/panel/management/sms/:id",
        campain: {
          list: "/panel/management/sms/campain/list",
          create: "/panel/management/sms/campain/create",
          edit: "/panel/management/sms/campain/:id",
        },
      },
      language: {
        create: "/panel/management/language/create",
        list: "/panel/management/language/list",
        edit: "/panel/management/language/edit/:id",
      },
      notifications: "/panel/management/notifications",
      users: "/panel/management/users",
      tags: {
        list: "/panel/management/tags",
        create: "/panel/management/tags/create",
        edit: "/panel/management/tags/:id",
      },
      loyalityLevel: {
        list: "/panel/management/loyalityLevel",
        create: "/panel/management/loyalityLevel/create",
        edit: "/panel/management/loyalityLevel/edit/:id",
      },
      foreignApi: {
        list: "/panel/management/foreignApi",
        create: "/panel/management/foreignApi/create",
        edit: "/panel/management/foreignApi/:id",
      },
      comments: {
        commentCategory: {
          list: "/panel/management/comments/commentCategory",
          create: "/panel/management/comments/commentCategory/create",
          edit: "/panel/management/comments/commentCategory/:id",
        },
        comment: {
          list: "/panel/management/comments/comment",
          create: "/panel/management/comments/comment/create",
          edit: "/panel/management/comments/comment/:id",
        },
      },
      socialNetworks: {
        list: "/panel/management/socialNetworks",
        create: "/panel/management/socialNetworks/create",
        edit: "/panel/management/socialNetworks/:id",
      },
      taskScheduler: "/panel/management/taskScheduler",
      theme: {
        list: "/panel/management/theme",
        create: "/panel/management/theme/create",
        edit: "/panel/management/theme/:id",
      },
      paymentGateway: {
        list: "/panel/management/paymentGateway",
        create: "/panel/management/paymentGateway/create",
        edit: "/panel/management/paymentGateway/:id",
      },
      menu: "/panel/management/menu",
    },
    domain: {
      list: "/panel/domain",
      create: "/panel/domain/create",
      update: "/panel/domain/update/:id",
      details: "/panel/domain/details/:id",
    },
    whitelabel: {
      representation: "/panel/whitelabel/representation",
      productOrder: "/panel/whitelabel/productOrder",
      productOrderAutoGift: "/panel/whitelabel/productOrderAutoGift",
      plan: {
        list: "/panel/whitelabel/list",
        create: "/panel/whitelabel/create",
        edit: "/panel/whitelabel/edit/:id",
        myPlan: "/panel/whitelabel/myplan",
      },
    },
    serviceProviderTesting: {
      account: {
        list: "/panel/serviceProviderTesting/account",
      },
      campain: {
        list: "/panel/serviceProviderTesting/campain",
        create: "/panel/serviceProviderTesting/campain/create",
        edit: "/panel/serviceProviderTesting/campain/:id",
        manual: "/panel/serviceProviderTesting/campain/:id/manual",
        result: "/panel/serviceProviderTesting/campain/:id/result",
      },
      campainServiceProvider: {
        list: "/panel/serviceProviderTesting/campainServiceProvider",
        accountFollowers:
          "/panel/serviceProviderTesting/campainServiceProvider/:id/accountFollowers",
      },
    },
    automationOrder: {
      list: "/panel/automationOrder",
    },
    whatsapp: {
      craeteClient: "/panel/whatsapp/createClient",
      editClient: "/panel/whatsapp/createClient/:id",
      listClient: "/panel/whatsapp/listClient",
    },
    whatsappCategory: {
      craete: "/panel/whatsappCategory/create",
      edit: "/panel/whatsappCategory/edit/:id",
      list: "/panel/whatsappCategory/list",
    },
    whatsappUsers: {
      craete: "/panel/whatsappUsers/create",
      craeteBulk: "/panel/whatsappUsers/createBulk",
      edit: "/panel/whatsappUsers/edit/:id",
      list: "/panel/whatsappUsers/list",
    },
    buyProduct: "/panel/buyProduct",
    payment: "/panel/payment",
    api: "/panel/api",
  },

  public: {
    HomeWhitelable: "/",
    services: "/public/services",
    maintenance: "/public/maintenance",
    checkout: "/public/checkout",
    payment: {
      success: "/public/payment/success",
      error: "/public/payment/error",
    },
  },
};

export default routes;
